import React from "react";
import { FlexCenter } from "../../../../layout/FlexCenter/FlexCenter";
import { Title } from "../../../../ui/Title";

export const Files = () => {
    return (
        <FlexCenter>
            <Title text={"Files"} size={"l"}/>
        </FlexCenter>
    )
}